export const paths = {
    homepage: "/",
    video: "/Video",
    pendulum: "/Pendulum",
    questionone: "/Questionone",

}